import { SvgIcon, Fab } from '@mui/material';
import React from 'react';
import { spaces, palette } from '../../../assets/styles/themes/tokens';
import getMuiIcon from '../../../utils/getMuiIcon';
import useScreenSize from '../../../utils/useScreenSize';
import useIntercom from '../../../utils/useIntercom';

interface ReturnTopButtonProps {
  onClick: () => void;
  isFullScreenMode: boolean;
}

const ReturnTopButton = ({ onClick, isFullScreenMode }: ReturnTopButtonProps) => {
  const { isMdScreen, isLgScreen } = useScreenSize();
  const isDesktopScreen = isLgScreen || isMdScreen;
  const { isIntercomVisible } = useIntercom();

  const offsetOnRight = isIntercomVisible && (isFullScreenMode || !isDesktopScreen);

  const fabSx = {
    position: 'absolute',
    bottom: isFullScreenMode ? spaces.xxxxxl : spaces.md,
    right: offsetOnRight ? spaces.xxxxl : 0,
    background: palette.background.paperElevation2,
  };
  return (
    <Fab 
      onClick={onClick}
      size='medium'
      sx={fabSx}
    >
      <SvgIcon viewBox='0 0 24 24' component={getMuiIcon('arrowUpLong')} />
    </Fab>
  );
};

export default ReturnTopButton;
